import { apiFetch } from '@shared/api/http'
import { AffiliationSchema, AffiliatePixelSchema } from './affiliation.contract'
import type { Affiliation, AffiliatePixel } from './affiliation.contract'

export async function createAffiliation(productId: string): Promise<Affiliation> {
  const data = await apiFetch<unknown>('/partnerships/affiliations', {
    method: 'POST',
    body: { productId },
  })
  return AffiliationSchema.parse(data)
}

export async function createAffiliationByInvite(token: string): Promise<Affiliation> {
  const data = await apiFetch<unknown>(`/partnerships/affiliations/by-invite/${token}`, {
    method: 'POST',
  })
  return AffiliationSchema.parse(data)
}

export async function approveAffiliation(affiliationId: string): Promise<Affiliation> {
  const data = await apiFetch<unknown>(`/partnerships/affiliations/${affiliationId}/approve`, {
    method: 'PATCH',
    body: {},
  })
  return AffiliationSchema.parse(data)
}

export async function rejectAffiliation(affiliationId: string): Promise<Affiliation> {
  const data = await apiFetch<unknown>(`/partnerships/affiliations/${affiliationId}/reject`, {
    method: 'PATCH',
  })
  return AffiliationSchema.parse(data)
}

export async function blockAffiliation(affiliationId: string): Promise<Affiliation> {
  const data = await apiFetch<unknown>(`/partnerships/affiliations/${affiliationId}/block`, {
    method: 'PATCH',
  })
  return AffiliationSchema.parse(data)
}

export async function getAffiliatePixels(affiliationId: string): Promise<AffiliatePixel[]> {
  const data = await apiFetch<unknown>(`/partnerships/affiliations/${affiliationId}/pixels`)
  return AffiliatePixelSchema.array().parse(data)
}

export async function updateAffiliatePixels(
  affiliationId: string,
  pixels: AffiliatePixel[],
): Promise<AffiliatePixel[]> {
  const data = await apiFetch<unknown>(`/partnerships/affiliations/${affiliationId}/pixels`, {
    method: 'PATCH',
    body: { pixels },
  })
  return AffiliatePixelSchema.array().parse(data)
}
